function parseWeek(key) {
  const part = String(key).split(' ').pop();
  const [ m, d, y ] = part.split('/').map(Number);
  return new Date(2000 + y, m - 1, d).getTime();
}

export function sortPeriods(periodKeys, periodicity) {
  const unique = [...new Set(periodKeys)];
  if (periodicity === 'Week') {
    return unique.sort((a, b) => parseWeek(a) - parseWeek(b));
  }
  if (periodicity === 'Month') {
    return unique.sort((a, b) => {
      const [ am, ay ] = a.split('/').map(Number);
      const [ bm, by ] = b.split('/').map(Number);
      return ay !== by ? ay - by : am - bm;
    });
  }
  return unique.sort((a, b) => Number(a) - Number(b));
}

export function getWeekNumber(periodKey) {
  if (!periodKey?.startsWith('W/s')) return '';
  const part = periodKey.split(' ').pop();
  const [ m, d, y ] = part.split('/').map(Number);
  const date = new Date(2000 + y, m - 1, d);
  const oneJan = new Date(date.getFullYear(), 0, 1);
  const days = Math.floor((date - oneJan) / 86400000);
  return `${Math.ceil((days + oneJan.getDay() + 1) / 7)}`;
}
